import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'wrapped-btc'),
  es: flattenMessages(es, 'wrapped-btc'),
  ru: flattenMessages(ru, 'wrapped-btc'),
  zh: flattenMessages(zh, 'wrapped-btc'),
};
